var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9029_1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.15681 0 0 7.156 0 16C0 24.8431 7.156 32 16 32C24.8432 32 32 24.844 32 16C32 7.15681 24.844 0 16 0ZM16 29.7674C8.40862 29.7674 2.23256 23.5914 2.23256 16C2.23256 8.40856 8.40862 2.23256 16 2.23256C23.5914 2.23256 29.7674 8.40856 29.7674 16C29.7674 23.5914 23.5914 29.7674 16 29.7674Z",
    fill: "#1D1E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5256 20.2452C14.6411 20.2452 13.925 20.9824 13.925 21.8669C13.925 22.7304 14.62 23.4886 15.5256 23.4886C16.4313 23.4886 17.1473 22.7304 17.1473 21.8669C17.1473 20.9824 16.4101 20.2452 15.5256 20.2452ZM15.7994 7.9668C12.9561 7.9668 11.6504 9.65173 11.6504 10.789C11.6504 11.6104 12.3454 11.9895 12.914 11.9895C14.0513 11.9895 13.588 10.3677 15.7362 10.3677C16.7892 10.3677 17.6317 10.8311 17.6317 11.7999C17.6317 12.9372 16.4523 13.59 15.7573 14.1797C15.1465 14.7062 14.3462 15.5697 14.3462 17.381C14.3462 18.4761 14.6411 18.792 15.5045 18.792C16.5365 18.792 16.7471 18.3287 16.7471 17.9285C16.7471 16.8334 16.7681 16.2015 17.9265 15.2959C18.4951 14.8537 20.2853 13.4215 20.2853 11.4418C20.2853 9.46211 18.4951 7.9668 15.7994 7.9668Z",
    fill: "#1D1E25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9029_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.4f5e211c46b143c549770c7e4d4e4f8f.svg";
export { ForwardRef as ReactComponent };